import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faUndo,
  faChartBar,
  faEye,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
import LeaseDetailsPopup from "../LeaseDetailsPopup";
import LeaseGraphPopup from "../LeaseGraphPopup";
import { getUserRole } from "../../utils/index";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const LeaseListingTable = ({ asset, brand, status, stateId }) => {
  //console.log(asset);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [leaseId, setLeaseId] = useState(0);
  const [popupKey, setpopupKey] = useState(0);
  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-view/get-all-leases?stateId=${stateId}&asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}&status=${status}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-view/get-all-leases?stateId=${stateId}&asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1&status=${status}`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalGraphOpen, setGraphOpen] = React.useState(false);

  function openFromParent() {
    setIsOpen(true);
  }

  function modalGraphClose() {
    setGraphOpen(false);
  }

  function handleCloseModal() {
    setIsOpen(false);
  }

  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Lease Id",
      selector: "leaseCode",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Cost Center",
      selector: "cost_center",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Asset Name",
      selector: "assetName",
      sortable: false,
      grow: 3,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Unit Number",
      selector: "unit_no",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "GLA (Sq.Ft.)",
      selector: "gross_leasable_area",
      sortable: false,
      grow: 1,
      wrap: true,
    },
    {
      name: "Brand Name / Occupier Name",
      selector: "brandName",
      sortable: false,
      grow: 2,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Lease Commencement Date",
      selector: "lcd",
      sortable: false,
      grow: 3,
    },
    {
      name: "Lease Term (YY-MM-DD)",
      selector: "leaseTerm",
      sortable: false,
      grow: 2,
    },
    {
      name: "Lease Expiry Date",
      selector: "leaseExpiryData",
      sortable: false,
      grow: 2,
      wrap: true,
    },
    {
      name: "Action",
      grow: 3,
      sortable: false,
      cell: (record) => {
        return (
          <div>
            <span className="tableActionView">
              <Link
                to={`/lease-summary/view-lease/lease-details/${record.leaseId}`}
              >
                {" "}
                <FontAwesomeIcon icon={faEye} />
              </Link>
            </span>
            <span
              className="tableActionAmend"
              onClick={(e) => {
                setLeaseId(record.leaseId);
                setpopupKey(Math.random());
                openFromParent();
              }}
            >
              <FontAwesomeIcon icon={faInfoCircle} />
            </span>

            <span
              className="tableActionAmend"
              onClick={(e) => {
                setLeaseId(record.leaseId);
                setpopupKey(Math.random());
                setGraphOpen(true);
              }}
            >
              <FontAwesomeIcon title="graph" icon={faChartBar} />
            </span>

            {getUserRole() == "checker" && record.status == 1 && (
              <span className="tableActionEdit">
                <Link to={`/checklease/lease-landlord/${record.leaseId}`}>
                  {" "}
                  <FontAwesomeIcon icon={faPen} />
                </Link>
              </span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="tableContainer">
        <DataTable
          
          columns={columns}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>
      <LeaseDetailsPopup
        IsModalOpened={modalIsOpen}
        onCloseModal={handleCloseModal}
        leaseId={leaseId}
        key={popupKey}
      />
      <LeaseGraphPopup
        IsModalOpened={modalGraphOpen}
        onCloseModal={modalGraphClose}
        leaseId={leaseId}
        key={popupKey}
      />
    </>
  );
};
export default LeaseListingTable;
